import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion"; // For animations
import logoImage from "../assets/images/Tirtho_Logo_w-o_Backgrnd.png"; // Verify this path
import { FaBars, FaTimes } from "react-icons/fa"; // Icons for mobile menu

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  // Framer Motion variants for animations
  const navVariants = {
    hidden: { y: -100, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
  };

  return (
    <motion.nav
      className="bg-gray-900 shadow-md fixed w-full z-50"
      variants={navVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo/Brand */}
          <motion.div
            className="flex items-center"
            variants={itemVariants}
            initial="hidden"
            animate="visible"
            transition={{ delay: 0.1 }}
          >
            <Link to="/" className="flex items-center">
              <img
                src={logoImage}
                alt="CodeTirtho97"
                className="h-16 md:h-16 sm:h-10 w-auto"
              />
            </Link>
          </motion.div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            {[
              "/",
              "/about",
              "/education",
              "/experience",
              "/projects",
              "/contact",
            ].map((path, index) => (
              <motion.div
                key={path}
                variants={itemVariants}
                initial="hidden"
                animate="visible"
                transition={{ delay: 0.1 + index * 0.1 }}
              >
                <Link
                  to={path}
                  className={`py-2 px-2 text-lg font-medium font-['Inter'] transition-colors duration-300 relative group ${
                    isActive(path)
                      ? "text-emerald-400"
                      : "text-gray-100 hover:text-emerald-400"
                  }`}
                >
                  {path === "/"
                    ? "Home"
                    : path.slice(1).charAt(0).toUpperCase() + path.slice(2)}
                  <span
                    className={`absolute bottom-0 left-0 w-full h-0.5 bg-emerald-400 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ${
                      isActive(path) ? "scale-x-100" : ""
                    }`}
                  ></span>
                </Link>
              </motion.div>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <motion.button
              className="text-gray-100 hover:text-emerald-400 p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.2 }}
            >
              {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </motion.button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <motion.div
            className="md:hidden bg-gray-900 p-4 space-y-4"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            {[
              "/",
              "/about",
              "/education",
              "/experience",
              "/projects",
              "/contact",
            ].map((path, index) => (
              <motion.div
                key={path}
                variants={itemVariants}
                initial="hidden"
                animate="visible"
                transition={{ delay: index * 0.1 }}
              >
                <Link
                  to={path}
                  className={`block py-2 px-2 text-lg font-medium font-['Inter'] ${
                    isActive(path)
                      ? "bg-emerald-400/20 text-emerald-400"
                      : "text-gray-100 hover:bg-emerald-400/20 hover:text-emerald-400"
                  } rounded-lg transition-colors duration-300`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {path === "/"
                    ? "Home"
                    : path.slice(1).charAt(0).toUpperCase() + path.slice(2)}
                </Link>
              </motion.div>
            ))}
          </motion.div>
        )}
      </div>
    </motion.nav>
  );
}

export default Navbar;
